"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = exports.createThemeVariant = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const elevation_1 = require("./elevation");
const Palette_1 = require("./Palette");
const Typography_1 = require("./Typography");
const DEFAULT_DARK_PALETTE = (0, Palette_1.createPalette)('dark');
const DEFAULT_LIGHT_PALETTE = (0, Palette_1.createPalette)('light');
function createThemeVariant(palette, typography) {
    return {
        components: {},
        elevation: elevation_1.elevation,
        palette,
        shape: {
            borderRadius: 4,
        },
        spacing: {
            unit: 8,
        },
        typography,
    };
}
exports.createThemeVariant = createThemeVariant;
class Theme {
    constructor(input = {}, ...overrides) {
        this.mode = 'light';
        const final = deepmerge_1.default.all([
            {
                key: 'bluebase-theme',
                name: 'BlueBase Theme',
                light: createThemeVariant(DEFAULT_LIGHT_PALETTE, (0, Typography_1.createTypography)(DEFAULT_LIGHT_PALETTE)),
                dark: createThemeVariant(DEFAULT_DARK_PALETTE, (0, Typography_1.createTypography)(DEFAULT_DARK_PALETTE)),
            },
            input,
            ...overrides,
        ]);
        this.key = final.key;
        this.name = final.name;
        this.light = final.light;
        this.dark = final.dark;
    }
    get components() {
        return this[this.mode].components;
    }
    get elevation() {
        return this[this.mode].elevation;
    }
    get palette() {
        return this[this.mode].palette;
    }
    get shape() {
        return this[this.mode].shape;
    }
    get spacing() {
        return this[this.mode].spacing;
    }
    get typography() {
        return this[this.mode].typography;
    }
}
exports.Theme = Theme;
